import {ofType} from 'redux-observable';
import {merge, type Observable, of} from 'rxjs';
import {flatMap, take} from 'rxjs/operators';

import * as Actions from './actions';

type SuccessPayload = ReturnType<typeof Actions.askForPasswordSuccess.action>;
type FailPayload = ReturnType<typeof Actions.askForPasswordFailed.action>;

export const makePasswordModalEpic =
    <T, P = any>(
        makeTrigger: (action$: any) => Observable<T>,
        onSuccess: (trigger: T, modalAction: SuccessPayload) => Observable<P>,
        onFail: (trigger: T, modalAction: FailPayload) => Observable<P>,
    ) =>
    action$ =>
        makeTrigger(action$).pipe(
            flatMap(triggerValue =>
                merge(
                    of(Actions.askForPassword.action()),
                    action$.pipe(ofType(Actions.askForPasswordSuccess.type, Actions.askForPasswordFailed.type)).pipe(
                        take(1),
                        flatMap<SuccessPayload | FailPayload, P>(modalAction => {
                            if (modalAction.type === Actions.askForPasswordSuccess.type) {
                                return onSuccess(triggerValue, modalAction as SuccessPayload);
                            }
                            return onFail(triggerValue, modalAction as FailPayload);
                        }),
                    ),
                ),
            ),
        );
